angular.
module("dx.webapp.library").
directive("dxLibraryQuestionItem", function libraryQuestionItemDirective() {
	"use strict";

	return {
		restrict: "E",
		require: "^^dxExamLibrary",
		scope: {
			question: "=",
			embedded: "=",
			expanded: "=",
		},
		templateUrl: "tmpl/library/library-question-item-directive.html",
		controller: "DxLibraryQuestionItemController",
		link: link,
	};

	function link($scope, $element, $attrs, requiredController) {
		$scope.dxExamLibraryCtrl = requiredController;
		$scope.selected = $scope.dxExamLibraryCtrl.questionSelected($scope.question.id);
	}
});
